import ErrorOrComingSoon from "@frameworks/shared-library/components/Orderbook/common/ErrorOrComingSoon";
import { EProductIds, EProductNames, EProductTypeNames, ESubProductIds, ESubProductNames, } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import React from "react";
import ManagePortfolio from "../ManagePortfolio";
import MutualFundOrders from "../ManagePortfolio/MutualFundOrders";
import ProductOrderBook from "@frameworks/pmsjourney/app/ProductOrderBook";
import OtcProductOrder from "@frameworks/NCD/pages/OrderBook/StructuredProducts";
import FixedIncome from "@frameworks/NCD/pages/OrderBook/FixedIncome";
import EquityAndMoreOrderBook from "@frameworks/NCD/pages/OrderBook/Equity";
export var bucketMap = new Map([
    [
        EProductTypeNames.Wealth_Product,
        [
            {
                eventKey: EProductIds.FIXED_INCOME,
                title: EProductNames.FIXED_INCOME,
                value: EProductIds.FIXED_INCOME,
                tabContent: React.createElement(FixedIncome, null),
            },
            {
                eventKey: EProductIds.GENERAL_INSURANCE,
                title: EProductNames.GENERAL_INSURANCE,
                value: EProductIds.GENERAL_INSURANCE,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: EProductIds.LIABILITIES,
                title: EProductNames.LIABILITIES,
                value: EProductIds.LIABILITIES,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: EProductIds.LIFE_INSURANCE,
                title: EProductNames.LIFE_INSURANCE,
                value: EProductIds.LIFE_INSURANCE,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: EProductIds.MANAGED_PORTFOLIO,
                title: EProductNames.MANAGED_PORTFOLIO,
                value: EProductIds.MANAGED_PORTFOLIO,
                tabContent: React.createElement(ManagePortfolio, null),
            },
            {
                eventKey: EProductIds.REAL_ESTATE,
                title: EProductNames.REAL_ESTATE,
                value: EProductIds.REAL_ESTATE,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: EProductIds.SUBSCRIPTION,
                title: EProductNames.SUBSCRIPTION,
                value: EProductIds.SUBSCRIPTION,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
        ],
    ],
    [
        EProductTypeNames.EquityAndMore,
        [
            {
                eventKey: EProductIds.DERIVATIVE,
                title: EProductNames.DERIVATIVE,
                value: EProductIds.DERIVATIVE,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: EProductIds.EQUITY,
                title: EProductNames.EQUITY,
                value: EProductIds.EQUITY,
                tabContent: React.createElement(EquityAndMoreOrderBook, null),
            },
            {
                eventKey: EProductIds.COMMODITY,
                title: EProductNames.COMMODITY,
                value: EProductIds.COMMODITY,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
        ],
    ],
]);
export var allProductsMap = new Map([
    [
        EProductIds.COMMODITY,
        [
            {
                eventKey: ESubProductIds.SGB,
                title: ESubProductNames.SGB,
                value: ESubProductIds.SGB,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
        ],
    ],
    [
        EProductIds.DERIVATIVE,
        [
            {
                eventKey: ESubProductIds.Commodity,
                title: ESubProductNames.Commodity,
                value: ESubProductIds.Commodity,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.Currency,
                title: ESubProductNames.Currency,
                value: ESubProductIds.Currency,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.Equity,
                title: ESubProductNames.Equity,
                value: ESubProductIds.Equity,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
        ],
    ],
    [
        EProductIds.EQUITY,
        [
            {
                eventKey: ESubProductIds.ListedShares,
                title: ESubProductNames.ListedShares,
                value: ESubProductIds.ListedShares,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.UnlistedShares,
                title: ESubProductNames.UnlistedShares,
                value: ESubProductIds.UnlistedShares,
                tabContent: (React.createElement(OtcProductOrder, { parentId: Number(EProductIds.EQUITY), subCategoryId: Number(ESubProductIds.UnlistedShares), isMultiple: false })),
            },
            {
                eventKey: ESubProductIds.SLBM,
                title: ESubProductNames.SLBM,
                value: ESubProductIds.SLBM,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.IDR,
                title: ESubProductNames.IDR,
                value: ESubProductIds.IDR,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.PreferenceShares,
                title: ESubProductNames.PreferenceShares,
                value: ESubProductIds.PreferenceShares,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.SMTF,
                title: ESubProductNames.SMTF,
                value: ESubProductIds.SMTF,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.OFS,
                title: ESubProductNames.OFS,
                value: ESubProductIds.OFS,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.IPO,
                title: ESubProductNames.IPO,
                value: ESubProductIds.IPO,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.Rights,
                title: ESubProductNames.Rights,
                value: ESubProductIds.Rights,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.Buyback,
                title: ESubProductNames.Buyback,
                value: ESubProductIds.Buyback,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.Smallcase,
                title: ESubProductNames.SmallCase,
                value: ESubProductIds.Smallcase,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
        ],
    ],
    [
        EProductIds.FIXED_INCOME,
        [
            {
                eventKey: ESubProductIds.Bonds,
                title: ESubProductNames.Bonds,
                value: ESubProductIds.Bonds,
                tabContent: (React.createElement(OtcProductOrder, { parentId: Number(EProductIds.FIXED_INCOME), subCategoryId: Number(ESubProductIds.Bonds), isMultiple: false })),
            },
            {
                eventKey: ESubProductIds.NCD,
                title: ESubProductNames.NCD,
                value: ESubProductIds.NCD,
                tabContent: (React.createElement(OtcProductOrder, { parentId: Number(EProductIds.FIXED_INCOME), subCategoryId: Number(ESubProductIds.NCD), isMultiple: false })),
            },
            {
                eventKey: ESubProductIds.CapitalGainsBond54EC,
                title: ESubProductNames.CapitalGainsBond54EC,
                value: ESubProductIds.CapitalGainsBond54EC,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.RBIBonds,
                title: ESubProductNames.RBIBonds,
                value: ESubProductIds.RBIBonds,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.CorporateFD,
                title: ESubProductNames.CorporateFD,
                value: ESubProductIds.CorporateFD,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.CommercialPaper,
                title: ESubProductNames.CommercialPaper,
                value: ESubProductIds.CommercialPaper,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.Warrant,
                title: ESubProductNames.Warrant,
                value: ESubProductIds.Warrant,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
        ],
    ],
    [
        EProductIds.GENERAL_INSURANCE,
        [
            {
                eventKey: ESubProductIds.MotorInsurance,
                title: ESubProductNames.MotorInsurance,
                value: ESubProductIds.MotorInsurance,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.HealthInsurance,
                title: ESubProductNames.HealthInsurance,
                value: ESubProductIds.HealthInsurance,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.FireInsurance,
                title: ESubProductNames.FireInsurance,
                value: ESubProductIds.FireInsurance,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.BurglaryInsurance,
                title: ESubProductNames.BurglaryInsurance,
                value: ESubProductIds.BurglaryInsurance,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.MarineInsurance,
                title: ESubProductNames.MarineInsurance,
                value: ESubProductIds.MarineInsurance,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.PAGroupInsurance,
                title: ESubProductNames.PAGroupInsurance,
                value: ESubProductIds.PAGroupInsurance,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.HealthGroupInsurance,
                title: ESubProductNames.HealthGroupInsurance,
                value: ESubProductIds.HealthGroupInsurance,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.MarineCargoInsurance,
                title: ESubProductNames.MarineCargoInsurance,
                value: ESubProductIds.MarineCargoInsurance,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
        ],
    ],
    [
        EProductIds.LIFE_INSURANCE,
        [
            {
                eventKey: ESubProductIds.SavingInvestmentInsurance,
                title: ESubProductNames.SavingInvestmentInsurance,
                value: ESubProductIds.SavingInvestmentInsurance,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.TermInsurance,
                title: ESubProductNames.TermInsurance,
                value: ESubProductIds.TermInsurance,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
        ],
    ],
    [
        EProductIds.LIABILITIES,
        [
            {
                eventKey: ESubProductIds.LAP,
                title: ESubProductNames.LAP,
                value: ESubProductIds.LAP,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.LAS,
                title: ESubProductNames.LAS,
                value: ESubProductIds.LAS,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.ESOP,
                title: ESubProductNames.ESOP,
                value: ESubProductIds.ESOP,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.HousingLoan,
                title: ESubProductNames.HousingLoan,
                value: ESubProductIds.HousingLoan,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.Mortgage,
                title: ESubProductNames.Mortgage,
                value: ESubProductIds.Mortgage,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.IPOFunding,
                title: ESubProductNames.IPOFunding,
                value: ESubProductIds.IPOFunding,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.Unsecured,
                title: ESubProductNames.Unsecured,
                value: ESubProductIds.Unsecured,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
        ],
    ],
    [
        EProductIds.MANAGED_PORTFOLIO,
        [
            {
                eventKey: ESubProductIds.MutualFund,
                title: ESubProductNames.MutualFund,
                value: ESubProductIds.MutualFund,
                tabContent: React.createElement(MutualFundOrders, null),
            },
            {
                eventKey: ESubProductIds.PMS,
                title: ESubProductNames.PMS,
                value: ESubProductIds.PMS,
                tabContent: (React.createElement(ProductOrderBook, { subCategoryId: Number(ESubProductIds.PMS) })),
            },
            {
                eventKey: ESubProductIds.ETF,
                title: ESubProductNames.ETF,
                value: ESubProductIds.ETF,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.StructuredProducts,
                title: ESubProductNames.StructuredProducts,
                value: ESubProductIds.StructuredProducts,
                tabContent: (React.createElement(OtcProductOrder, { parentId: Number(EProductIds.MANAGED_PORTFOLIO), subCategoryId: Number(ESubProductIds.StructuredProducts), isMultiple: false })),
            },
            {
                eventKey: ESubProductIds.AIF,
                title: ESubProductNames.AIF,
                value: ESubProductIds.AIF,
                tabContent: (React.createElement(ProductOrderBook, { subCategoryId: Number(ESubProductIds.AIF) })),
            },
            {
                eventKey: ESubProductIds.INVITs,
                title: ESubProductNames.INVITs,
                value: ESubProductIds.INVITs,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
            {
                eventKey: ESubProductIds.NFO,
                title: ESubProductNames.NFO,
                value: ESubProductIds.NFO,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
        ],
    ],
    [
        EProductIds.REAL_ESTATE,
        [
            {
                eventKey: ESubProductIds.REITs,
                title: ESubProductNames.REITs,
                value: ESubProductIds.REITs,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
        ],
    ],
    [
        EProductIds.SUBSCRIPTION,
        [
            {
                eventKey: ESubProductIds.Infinity,
                title: ESubProductNames.Infinity,
                value: ESubProductIds.Infinity,
                tabContent: React.createElement(ErrorOrComingSoon, null),
            },
        ],
    ],
]);
// export const allSubProductMap = new Map([
// Manage Portfolio
// [ESubProductNames.MutualFund, <ErrorOrComingSoon />],
// [ESubProductNames.PMS, <ErrorOrComingSoon />],
// [ESubProductNames.ETF, <ErrorOrComingSoon />],
// [ESubProductNames.StructuredProducts, <ErrorOrComingSoon />],
// [ESubProductNames.AIF, <ErrorOrComingSoon />],
// [ESubProductNames.INVITs, <ErrorOrComingSoon />],
// [ESubProductNames.NFO, <ErrorOrComingSoon />],
// Derivative
// [ESubProductNames.Commodity, <ErrorOrComingSoon />],
// [ESubProductNames.Currency, <ErrorOrComingSoon />],
// [ESubProductNames.Equity, <ErrorOrComingSoon />],
// EQUITY
// [ESubProductNames.ListedShares, <ErrorOrComingSoon />],
// [ESubProductNames.UnlistedShares, <ErrorOrComingSoon />],
// [ESubProductNames.SLBM, <ErrorOrComingSoon />],
// [ESubProductNames.IDR, <ErrorOrComingSoon />],
// [ESubProductNames.PreferenceShares, <ErrorOrComingSoon />],
// [ESubProductNames.SMTF, <ErrorOrComingSoon />],
// [ESubProductNames.OFS, <ErrorOrComingSoon />],
// [ESubProductNames.IPO, <ErrorOrComingSoon />],
// [ESubProductNames.Rights, <ErrorOrComingSoon />],
// [ESubProductNames.Buyback, <ErrorOrComingSoon />],
// [ESubProductNames.Smallcase, <ErrorOrComingSoon />],
// FIXED_INCOME
// [ESubProductNames.Bonds, <ErrorOrComingSoon />],
// [ESubProductNames.NCD, <ErrorOrComingSoon />],
// [ESubProductNames.CapitalGainsBond54EC, <ErrorOrComingSoon />],
// [ESubProductNames.RBIBonds, <ErrorOrComingSoon />],
// [ESubProductNames.CorporateFD, <ErrorOrComingSoon />],
// [ESubProductNames.CommercialPaper, <ErrorOrComingSoon />],
// [ESubProductNames.Warrant, <ErrorOrComingSoon />],
// GENERAL_INSURANCE
// [ESubProductNames.MotorInsurance, <ErrorOrComingSoon />],
// [ESubProductNames.HealthInsurance, <ErrorOrComingSoon />],
// [ESubProductNames.FireInsurance, <ErrorOrComingSoon />],
// [ESubProductNames.BurglaryInsurance, <ErrorOrComingSoon />],
// [ESubProductNames.MarineInsurance, <ErrorOrComingSoon />],
// [ESubProductNames.PAGroupInsurance, <ErrorOrComingSoon />],
// [ESubProductNames.HealthGroupInsurance, <ErrorOrComingSoon />],
// [ESubProductNames.MarineCargoInsurance, <ErrorOrComingSoon />],
// LIABILITIES
// [ESubProductNames.LAP, <ErrorOrComingSoon />],
// [ESubProductNames.LAS, <ErrorOrComingSoon />],
// [ESubProductNames.ESOP, <ErrorOrComingSoon />],
// [ESubProductNames.HousingLoan, <ErrorOrComingSoon />],
// [ESubProductNames.Mortgage, <ErrorOrComingSoon />],
// [ESubProductNames.IPOFunding, <ErrorOrComingSoon />],
// [ESubProductNames.Unsecured, <ErrorOrComingSoon />],
// REAL_ESTATE
// [ESubProductNames.REITs, <ErrorOrComingSoon />],
// SUBSCRIPTION
// [ESubProductNames.Infinity, <ErrorOrComingSoon />],
// COMMODITY
// [ESubProductNames.SGB, <ErrorOrComingSoon />],
// LIFE_INSURANCE
// [ESubProductNames.SavingInvestmentInsurance, <ErrorOrComingSoon />],
// [ESubProductNames.TermInsurance, <ErrorOrComingSoon />],
// ]);
